import type { Schema_Wohnsituation } from 'cpool-schemas';

import { Address } from './Address';
import { Children } from './Children';
import { Haushalt } from './Haushalt';
import type { CreateApplicantFormValues } from '../../util/schemaCreateApplicantForm';

type Props = {
    mainApplicantWohnsituation: Schema_Wohnsituation;
    sameHouseholdValues: CreateApplicantFormValues['wohnsituation'] | null;
    onSaveSameHouseholdValues: (values: CreateApplicantFormValues['wohnsituation']) => void;
};

export const LivingSituation: React.FC<Props> = ({
    mainApplicantWohnsituation,
    onSaveSameHouseholdValues,
    sameHouseholdValues,
}) => {
    return (
        <div className="flex w-full flex-col gap-2">
            <Address
                mainApplicantWohnsituation={mainApplicantWohnsituation}
                savedWohnsituation={sameHouseholdValues}
                onSaveWohnsituationValues={onSaveSameHouseholdValues}
            />
            <Haushalt />
            <Children />
        </div>
    );
};
